import React from 'react';

export default class ResellerTable extends React.Component {

    state = {
        
    }

    editReseller(i){
        this.props.editFunction(i)
    }

    deleteReseller(i){
        this.props.deleteFunction(i)
    }

    changeState(state, e){
        this.props.changeState(state, e.target.value);
    }

    render() {
        return (
            <div className="component reseller_table">
                <div className="panel pl-0 pr-0 pt-0 pb-0">
                    <table className="bordered">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Company</th>
                                <th>Address</th>
                                <th>Description</th>
                                <th>Email</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Phone</th>
                                <th>Manager</th>
                                <th className=""></th>
                            </tr>
                        </thead>
                        <tbody>
                            {(this.props.resellers) &&
                                this.props.resellers.map((reseller, i)=>{
                                    return <tr key={i}>
                                                <td>{reseller.id}</td>
                                                <td>{reseller.company}</td>
                                                <td>{reseller.address}</td>
                                                <td>{reseller.description}</td>
                                                <td>{reseller.email}</td>
                                                <td>{reseller.firstName}</td>
                                                <td>{reseller.lastName}</td>
                                                <td>{reseller.phone}</td>
                                                <td>{(reseller.manager) ? reseller.manager.company : ''}</td>
                                                <td className="actions">
                                                    {(this.props.user.userType.permissions.find((el) => el.id === 52)) &&
                                                    <div className="dropdown">
                                                        <button className="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">                                                            
                                                        </button>
                                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                            <button className="dropdown-item"
                                                                onClick={this.editReseller.bind(this, i)}
                                                            >Edit</button>
                                                            <button className="dropdown-item" href="#"
                                                                onClick={this.deleteReseller.bind(this, i)}
                                                            >Delete</button>
                                                        </div>
                                                    </div>
                                                    }
                                                </td>
                                            </tr>
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}